import { RootState } from "../../../../system/redux/store/community-finder-redux-store";

export const selectRteApiData = (state: RootState) => state?.results?.rte;
